<script >export let width = `1em`;
export let height = width;
export let style = ``;
</script>

<svg {width} {height} {style} viewBox="0 0 20 20" fill="currentColor">
  <path
    d="M10 1.6a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8zm4.789 11.461L13.06 14.79 10 11.729l-3.061 3.06L5.21 13.06 8.272 10 5.211 6.939 6.94 5.211 10 8.271l3.061-3.061 1.729 1.729L11.728 10l3.061 3.061z" />
</svg>
